import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
  import { DownOutlined } from '@ant-design/icons-vue';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    expand: { type: Boolean },
  },
  setup(__props) {

_useCssVars(_ctx => ({
  "v08006a43": (turn.value)
}))

  const props = __props;

  /**
   * @description 展开/收起 图标旋转转数
   */
  const turn = computed(() => `${props.expand ? 0 : 0.5}turn`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DownOutlined), { class: "collapse-icon" }))
}
}

})